import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = {
    chartData: Object,
    title: String
  };

  connect() {
    this.initChart();
  }

  initChart() {
    const canvas = this.element.querySelector('canvas');
    if (!canvas || !window.Chart) {
      return;
    }
    
    const ctx = canvas.getContext('2d');
    
    new window.Chart(ctx, {
      type: 'line',
      data: this.chartDataValue,
      options: {
        responsive: true,
        maintainAspectRatio: false,
        interaction: {
          mode: 'index',
          intersect: false,
        },
        plugins: {
          legend: {
            display: true,
            position: 'top',
          },
          tooltip: {
            mode: 'index',
            intersect: false,
          }
        },
        scales: {
          x: {
            display: true,
            title: {
              display: true,
              text: 'Date'
            },
            grid: {
              display: false
            }
          },
          y: {
            display: true,
            title: {
              display: true,
              text: 'Event Count'
            },
            beginAtZero: true,
            ticks: {
              precision: 0
            }
          }
        },
        elements: {
          point: {
            radius: 4,
            hoverRadius: 6
          }
        }
      }
    });
  }
}